import React, { Component } from 'react';

import { bool, string } from 'prop-types';
import debounce from 'lodash/debounce';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

/** Loading component for KPI KeyValue blocks */
class KPILoader extends Component {
  constructor(props) {
    super(props);

    this.mq = window.matchMedia('(min-width: 50em)');

    this.state = {
      isSmallScreen: !this.mq.matches,
    };
  }

  componentDidMount() {
    this.mq.addListener(this.toggleBreakpoint);
  }

  componentWillUnmount() {
    this.mq.removeListener(this.toggleBreakpoint);
  }

  /** When resizing, change the state accordingly */
  toggleBreakpoint = debounce(
    ({ matches }) => this.setState({ isSmallScreen: !matches }),
    250
  );

  render() {
    const {
      showPrevious,
      showChange,
      uniqueKey,
      showRow,
      showColumn,
    } = this.props;

    const { isSmallScreen } = this.state;

    /** Display a different skeleton loader on small screens */
    // These keys are only used to make the tests more predictable
    // Do not use them in production!
    const uniqueKey1 = uniqueKey ? `${uniqueKey}-1` : undefined;
    const uniqueKey2 = uniqueKey ? `${uniqueKey}-2` : undefined;

    if (showColumn) {
      if (!showPrevious && !showChange) {
        return (
          <ContentLoader width={375} height={90} uniquekey={uniqueKey2}>
            <rect width="50" height="15" x="0" y="10" />
            <rect width="55" height="25" x="0" y="35" />
          </ContentLoader>
        );
      }
      return (
        <ContentLoader width={375} height={90} uniquekey={uniqueKey2}>
          <rect width="60" height="15" x="0" y="10" />
          <rect width="70" height="25" x="70" y="0" />
          {(showPrevious || (!showPrevious && showChange)) && (
            <>
              <rect width="62" height="15" x="0" y="42" />
              <rect width="50" height="17" x="72" y="40" />
            </>
          )}
          {showPrevious && showChange && (
            <>
              <rect width="60" height="15" x="0" y="72" />
              <rect width="10" height="11" x="70" y="76" />
              <rect width="48" height="17" x="85" y="70" />
            </>
          )}
        </ContentLoader>
      );
    }

    if (showRow) {
      return (
        <ContentLoader width={375} height={90} uniquekey={uniqueKey2}>
          <rect width="60" height="10" x="0" y="0" />
          <rect width="80" height="35" x="0" y="17.5" />
          {(showPrevious || (!showPrevious && showChange)) && (
            <>
              <rect width="60" height="10" x="150" y="10" />
              <rect width="40" height="15" x="150" y="25" />
            </>
          )}
          {showPrevious && showChange && (
            <>
              <rect width="60" height="10" x="280" y="10" />
              <rect width="75" height="15" x="280" y="25" />
            </>
          )}
        </ContentLoader>
      );
    }

    return isSmallScreen ? (
      <ContentLoader width={320} height={48} uniquekey={uniqueKey1}>
        <rect width="60" height="10" x="0" y="0" />
        <rect width="80" height="30" x="0" y="15" />
        {(showPrevious || (!showPrevious && showChange)) && (
          <>
            <rect width="60" height="10" x="128" y="0" />
            <rect width="40" height="20" x="128" y="25" />
          </>
        )}
        {showPrevious && showChange && (
          <>
            <rect width="60" height="10" x="224" y="0" />
            <rect width="40" height="20" x="224" y="25" />
          </>
        )}
      </ContentLoader>
    ) : (
      <ContentLoader width={156} height={100} uniquekey={uniqueKey2}>
        <rect width="60" height="10" x="0" y="0" />
        <rect width="80" height="35" x="0" y="17.5" />
        {(showPrevious || (!showPrevious && showChange)) && (
          <>
            <rect width="60" height="10" x="0" y="65" />
            <rect width="40" height="15" x="0" y="80" />
          </>
        )}
        {showPrevious && showChange && (
          <>
            <rect width="60" height="10" x="96" y="65" />
            <rect width="40" height="15" x="96" y="80" />
          </>
        )}
      </ContentLoader>
    );
  }
}

KPILoader.propTypes = {
  /** Show the 'previous' skeleton placeholder  */
  showPrevious: bool,
  /** Show the 'change' skeleton placeholder */
  showChange: bool,
  /** Unique key for react-content-loader */
  uniqueKey: string,
  /** How to show the skeleton placeholder */
  showRow: bool,
  /** How to show the skeleton placeholder */
  showColumn: bool,
};

export default KPILoader;
